const feVersion = {
    ciBuildNumberTemplate: '20261103.16',
    ciBranchNameTemplate: 'dev',
    ciCommitIdTemplate: '4a416577809f16909ff116380c4ab65a73795aec',
    buildNumber: 440,
    version: '3.8.0',
    databaseVersion: 30800,
    shortCommitId: function () {
        if (this.ciCommitIdTemplate.length > 7 && !this.ciCommitIdTemplate.startsWith('#')) {
            return this.ciCommitIdTemplate.substring(0, 7);
        }
        return this.ciCommitIdTemplate;
    }
};

export default feVersion;
